// extracted by mini-css-extract-plugin
export default {"infoPage":"InfoPage_infoPage__MMf7b","pageTitle":"InfoPage_pageTitle__GLE-t","infoContent":"InfoPage_infoContent__4UqE9","videoFrame":"InfoPage_videoFrame__h858K"};